import { render, staticRenderFns } from "./order-address.vue?vue&type=template&id=4324a5c8"
import script from "./order-address.vue?vue&type=script&lang=js"
export * from "./order-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports